import {gsap} from 'gsap';

let subPageIndex = 1;

const subPageAnimation = {
  'section-4-1': gsap.timeline({paused: true})
      .addLabel('start')
      .from('.section-4-1__title', {opacity: 0, y: '+=20', duration: 1}, 'start+=.6')
      .staggerFrom(
          '.section-4-1__con li',
          0.6, {y:50, opacity:0,ease: "power2.out",}, 0.1, 'start+=1.1'),


  'section-4-2': gsap.timeline({paused: true})
      .addLabel('start')
      .from('.section-4-2__title', {opacity: 0, y: '+=20', duration: 1}, 'start+=.6')
      .from('.section-4-2__con1', {opacity: 0, y: '+=40', duration: .6}, 'start+=.8')
      .from('.section-4-2__con2', {opacity: 0, y: '+=60', duration: .6}, 'start+=1'),
};

const mountAnimation = gsap.timeline({paused: true})
    .addLabel('start')
    .from('.section-4__menu', {opacity: 0, duration: 1}, 'start+=.6');


const mountAnimation2 = gsap.timeline({paused: true})
    .addLabel('start')
    .from('.section-4__man', {opacity: 0, scale:3, x: '-=800', duration: .9,ease: "power4.out"}, 'start+=.4');



const SubPageRouter = (toPageIndex, delay = 0) => {
  let prevPageIndex = subPageIndex;

  $('.section-4__menu-item--active').removeClass('section-4__menu-item--active');
  $(`.section-4__menu-item--${toPageIndex}`).addClass('section-4__menu-item--active');
  $('.section-4__menu')
      .removeClass(`section-4__menu--active-1 
                    section-4__menu--active-2`)
      .addClass(`section-4__menu--active-${toPageIndex}`);

  $('.section-4__con--active').removeClass('section-4__con--active');
  $(`.section-4-${toPageIndex}`).addClass('section-4__con--active');

  if (prevPageIndex !== toPageIndex) {
    subPageAnimation[`section-4-${toPageIndex}`].restart();
  }
  else {
    setTimeout(() => {
      subPageAnimation[`section-4-${prevPageIndex}`].restart();
    }, 600);
  }

  subPageIndex = toPageIndex;
};

$(document).on('click', '.section-4__menu-item a', (e) => {
  e.preventDefault();
  let index = e.target.hash.replace(/(#s|s)ection-\d-/, '');
  if (subPageIndex == index) return;

  SubPageRouter(index);
});



export default {
  id: '#section-4',

  name: '신 서버',

  enterStart() {
    mountAnimation.play();
    mountAnimation2.play();
    SubPageRouter(subPageIndex);
  },

  leaveEnd() {
    mountAnimation.seek(0).pause();
    subPageAnimation[`section-4-${subPageIndex}`].seek(0).pause();
  }
};



// WEBPACK FOOTER //
// ./src/js/pc/section-4.js